/** @format */

var CustomFieldInput = require("./CustomFieldInput")

/**
 * @constructor CustomScreenForm
 * @param {*} customScreen
 * @param {*} customProperties
 */
function CustomScreenForm(customScreens, customProperties) {
  this.screenInputs = {};
}

CustomScreenForm.prototype = Object.create({});

CustomScreenForm.prototype.getInputs = function (customScreens, customProperties) {
  if (!customScreens || customScreens.length == 0) {
    return [];
  }

  return customScreens.map(
    function (screen) {
      if (!this.screenInputs[screen.id]) {
        this.screenInputs[screen.id] = this.createScreenInputs(screen, customProperties);
      }

      return this.screenInputs[screen.id];
    }.bind(this)
  );
};

CustomScreenForm.prototype.updateInputs = function (customScreens, customProperties) {
  if (!customScreens || customScreens.length == 0) {
    return [];
  }

  customScreens.forEach(
    function (screen) {
      var screenInputs = this.screenInputs[screen.id];

      if (screenInputs) {
        screenInputs.inputs.forEach(function (input) {
          var hasValue = Object.keys(customProperties).includes(input.name());
          if (hasValue) {
            input.value(customProperties[input.name()]);
          }
        });
      }
    }.bind(this)
  );

  // consuming caller expects an array
  return customScreens.map(
    function (customScreen) {
      return this.screenInputs[customScreen.id];
    }.bind(this)
  );
};

CustomScreenForm.prototype.updateInitialValues = function (customScreens, customProperties) {
  if (!customScreens || customScreens.length == 0) {
    return [];
  }

  customScreens.forEach(
    function (screen) {
      var screenInputs = this.screenInputs[screen.id];

      if (screenInputs && screenInputs.inputs) {
        screenInputs.inputs.forEach(function (input) {
          var hasValue = Object.keys(customProperties).includes(input.name());
          if (hasValue) {
            input.initialValue(customProperties[input.name()]);
          }
        });
      }
    }.bind(this)
  );

  // consuming caller expects an array
  return customScreens.map(
    function (customScreen) {
      return this.screenInputs[customScreen.id];
    }.bind(this)
  );
};

CustomScreenForm.prototype.cleanInputs = function (customScreens) {
  customScreens.forEach(
    function (screen) {
      var screenInputs = this.screenInputs[screen.id];
      if (screenInputs && screenInputs.inputs) {
        screenInputs.inputs.forEach(function (input) {
          input.clean();
        });
      }
    }.bind(this)
  );

  // consuming caller expects an array
  return customScreens.map(
    function (customScreen) {
      return this.screenInputs[customScreen.id];
    }.bind(this)
  );
};

/**
 * Create models to manage the actual form input for the Custom Fields
 *
 * @param {Array<CustomScreenModel>} customScreens
 * @returns  {Array<{screen: CustomScreenModel, inputs:Array<CustomFieldInputViewModel}>}
 */
CustomScreenForm.prototype.createScreenInputs = function (customScreen, customPropertyValues) {
  return {
    screen: customScreen,
    inputs:
      customScreen && customScreen.fields
        ? customScreen.fields.reduce(function (customPropertyInputs, field) {
            var initialValue =
              customPropertyValues && customPropertyValues[field.name] ? customPropertyValues[field.name] : null;
            var input = new CustomFieldInput(field, initialValue, self);
            customPropertyInputs.push(input);
            return customPropertyInputs;
          }, [])
        : [],
  };
};

CustomScreenForm.prototype.isValid = function (customScreens) {
  return customScreens
    .map(
      function (screen) {
        var inputs = [];
        if (this.screenInputs[screen.id] && this.screenInputs[screen.id].inputs) {
          inputs = this.screenInputs[screen.id].inputs;
        }

        return inputs.every(function (input) {
          input.validate();
          return input.isRequired() || !input.isEmpty() ? input.isValid() : true;
        });
      }.bind(this)
    )
    .every(function (screenResult) {
      return screenResult;
    });
};

CustomScreenForm.prototype.isDirty = function (customScreens) {
  return customScreens
    .map(
      function (screen) {
        var inputs = [];
        if (this.screenInputs[screen.id] && this.screenInputs[screen.id].inputs) {
          inputs = this.screenInputs[screen.id].inputs;
        }

        return inputs.some(function (input) {
          return input.isDirty();
        });
      }.bind(this)
    )
    .some(function (isDirtyScreen) {
      return isDirtyScreen;
    });
};

CustomScreenForm.prototype.getValues = function (customScreens) {
  return customScreens.reduce(function (values, screen) {
    var inputs = [];

    if (this.screenInputs[screen.id] && this.screenInputs[screen.id].inputs) {
      inputs = this.screenInputs[screen.id].inputs;
    }

    return Object.assign(
      values,
      inputs.reduce(function (inputValues, input) {
        inputValues[input.name()] = input.value();
        return inputValues;
      }, {})
    );
  }.bind(this), {});
};

CustomScreenForm.prototype.getFieldIdsAndValues = function (customScreens) {
  return customScreens.reduce(
    function (values, screen) {
      var inputs = [];

      if (this.screenInputs[screen.id] && this.screenInputs[screen.id].inputs) {
        inputs = this.screenInputs[screen.id].inputs;
      }

      return Object.assign(
        values,
        inputs.reduce(function (inputValues, input) {
          inputValues[input.id()] = input.value();
          return inputValues;
        }, {})
      );
      }.bind(this), 
      {}
  );
};

module.exports = CustomScreenForm;
